<nav class="navbar navbar-expand-md bg-dark navbar-dark fixed-top">
  <a class="navbar-brand" href="/">AzKho</a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsibleNavbar" id="btn1234">
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="collapsibleNavbar">
    <ul class="navbar-nav mr-auto">
      <!--<li class="nav-item">
        <a class="nav-link" href="{{contextPath}}/daily">Hợp tác</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" href="{{contextPath}}/service">Dịch vụ</a>
      </li> -->
      <!-- <li class="nav-item">
        <a class="nav-link" href="{{contextPath}}/price">Bảng giá</a>
      </li> -->
      <li class="nav-item">
        <a class="nav-link" href="{{contextPath}}/contact">Liên hệ</a>
      </li>

    </ul>
    <ul class="navbar-nav">
      <button type="button" class="btn btn-outline-secondary" [routerLink]="['/signin']">Đăng nhập</button>
      <button type="button" class="btn btn-outline-success" [routerLink]="['/registration']">Dùng thử</button>
    </ul>
  </div>
</nav>
